import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDark = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Icons_UI_Dropdown_Dropdown-Caret_Dark",
	"data-name": "Icons & UI/Dropdown/Dropdown-Caret_Dark",
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Icon",
		d: "M11.709,1.71l-5,5a1.014,1.014,0,0,1-1.42,0l-5-5A1,1,0,0,1,.079.62.987.987,0,0,1,1,0H11a.987.987,0,0,1,.92.62,1,1,0,0,1-.21,1.09",
		transform: "translate(12 15)",
		fill: "#102b61"
	})
});
export { SvgCaretDark as ReactComponent };
